/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React, { Component } from 'react';
import TableRowComponentHOC from './TableRowComponent';
import { ITableComponentProps, IRow } from '../types/tableVisualizationTypes';
import { TableCellComponent } from './TableCellComponent';

export default class TableComponent extends Component<ITableComponentProps> {
    render() {
        const {
            rows,
            offsetTop,
            linkToRefObjectPairs,
            linkOptions
        } = this.props;
        const Row = TableRowComponentHOC(TableCellComponent);
        const mappedRows = rows.map((row: IRow, index: number) => (
            <Row
                linkToRefObjectPairs={linkToRefObjectPairs}
                key={row.id}
                row={row}
                relativeIndex={index}
                linkOptions={linkOptions}
            />
        ));

        return (
            <table
                className="jr-mDatatable jr jr-jTableBody"
                style={{ position: 'absolute', top: offsetTop }}
                unselectable="on"
                js-stdnav="true"
                js-navtype="table"
                aria-label="Table. Use Alt and direction arrow keys for pagination"
            >
                <tbody className="jr-mDatatable-body jr">{mappedRows}</tbody>
            </table>
        );
    }
}
